import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";

import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';

import { warehouseReceivingOrdersIndex } from '../../redux/actions/receivingOrders';

const WarehouseReceivingOrders = ({ payload, loadWarehouseReceivingOrders, receivingOrders, accountUnits }) => {
  const { id } = useParams();

  useEffect(() => {
    loadWarehouseReceivingOrders(payload, id);
  }, []);

  const format = (value) => {
    return (accountUnits.currencyPrefix + (parseFloat(value) || 0).toFixed(parseInt(accountUnits.currencyPrecision)) + accountUnits.currencySuffix).replace('.', accountUnits.currencyDecimalSeparator);
  }


  return(
    <>
      <PageHeader stripeBackground='#fbe194' helpLink="ecwid/create-a-warehouse-receiving-order-2/" />
      <div className="settings-page cf">
        <div className="settings-page__header">

          <div className="named-area">

            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Warehouse Receiving Orders</div>
              </div>
              <div className="named-area__description">
                <p>View the list of warehouse receiving orders for this purchase order.</p>
                <p>As the purchase order gets received, more receiving orders will appear in this list.</p>
              </div>
            </div>

            <div className="named-area__body">
              <div className="a-card-stack">
                
                <div className="a-card a-card--normal">
                  <div className="a-card__paddings">

                    {/*<div>
                      <p>Labels and barcode labels can be generated for items in received orders with the <a href="" target="_blank">Barcode Inventory Management</a> app.</p>
                      <p>Warehouse Receiving Orders are automatically sent to the Barcode Inventory Managment app and can be printed in the <a href="" target="_blank">Print from Warehouse Receiving Orders</a> tool.</p>
                    </div>*/}

                    { (receivingOrders.status !== 'success') &&
                      <LoadingSpinner statusText="Loading Warehouse Receiving Orders" />
                    }

                  </div>
                </div>

              </div>
            </div>
          </div>

          { (receivingOrders.status === 'success') && receivingOrders?.receivingOrders?.warehouse_receiving_orders?.map(warehouseReceivingOrder =>
            <div className="named-area">

              <div className="named-area__header">
                <div className="named-area__titles">
                  <div className="named-area__title"></div>
                </div>
                <div className="named-area__description">
                  
                </div>
              </div>

              <div className="named-area__body">
                <div className="a-card-stack">

                  <div className="a-card a-card--normal">
                    <div className="a-card__paddings">


                      <div className="flex-container">
                        <div className="flex-1">
                          <h4>
                            <strong>WRO ID:</strong> { warehouseReceivingOrder.id }
                          </h4>
                          <h4>
                            <strong>Received Date:</strong> { warehouseReceivingOrder.received_at }
                          </h4>
                        </div>
                        <div className="flex-1 text-right">
                          <p>
                            <strong>
                              Update Processing: &nbsp;&nbsp;
                            </strong>
                          { !warehouseReceivingOrder.ticket &&
                            <div className="text-small info">
                              No processing recorded
                            </div>
                          }
                          { warehouseReceivingOrder?.ticket_status?.status &&
                            <div className="text-small success">
                              { warehouseReceivingOrder?.ticket_status?.status }
                            </div>
                          }
                          { warehouseReceivingOrder?.ticket_status?.errorMessage &&
                            <div className="text-small error">
                              { warehouseReceivingOrder?.ticket_status?.errorMessage }
                            </div>
                          }
                          </p>
                        </div>
                      </div>


                      { warehouseReceivingOrder.warehouse_receiving_order_lines.warehouse_receiving_order_lines.map(warehouseReceivingOrderLine =>
                        <div className="has-hover sku-line flex-container">
                          <div className="flex-container">
                            <div className="left-15">
                              { warehouseReceivingOrderLine.purchase_order_line.source_image_url && <img src={warehouseReceivingOrderLine.purchase_order_line.source_image_url} /> }
                              { !warehouseReceivingOrderLine.purchase_order_line.source_image_url && <p>No image</p>}
                            </div>
                          </div>

                          <div className="flex-2">
                            <div className="left-15">
                              <h4>Line Details</h4>
                              <ul>
                                <li><strong>Supplier SKU</strong>: <span className="inline-text-tag">{warehouseReceivingOrderLine.purchase_order_line.supplier_sku || "Not set"}</span></li>
                                <li><strong>Supplier Price</strong>: <span className="inline-text-tag">{warehouseReceivingOrderLine.purchase_order_line.supplier_price ? format(warehouseReceivingOrderLine.purchase_order_line.supplier_price) : "Not set"}</span></li>
                                { (parseInt(warehouseReceivingOrderLine.pack_quantity) > 1) &&
                                  <li>
                                    <strong>Pack Quantity</strong>: <span className="inline-text-tag">{warehouseReceivingOrderLine.pack_quantity}</span>
                                  </li>
                                }
                              </ul>
                            </div>
                          </div>

                          <div className="flex-2">
                            <div className="flex-container">
                              <h4>{warehouseReceivingOrderLine.purchase_order_line.source_name}</h4>
                            </div>
                            <ul>
                              { warehouseReceivingOrderLine.purchase_order_line.source_options && warehouseReceivingOrderLine.purchase_order_line.source_options.map(option =>
                                  <li>
                                    <strong>{ option.name }</strong>: <span className="inline-text-tag inline-text-tag--light-half">{ option.value }</span>
                                  </li>
                                )
                              }
                              { !warehouseReceivingOrderLine.purchase_order_line.source_options &&
                                <div className="text-small warning">
                                  Base Product
                                </div>
                              }
                            </ul>

                          </div>
                          <div className="flex-1">
                            <h4>Received Count</h4>
                            { warehouseReceivingOrderLine.count }
                            { (parseInt(warehouseReceivingOrderLine.pack_quantity) > 1) &&
                              <>
                                <p>x {warehouseReceivingOrderLine.pack_quantity} ({parseInt(warehouseReceivingOrderLine.pack_quantity) * warehouseReceivingOrderLine.count } total)</p>
                              </>
                            }
                          </div>
                        </div>

                      )}


                    </div>
                  </div>
                </div>
              </div>
            </div>
                
          )}

        </div>
      </div>
    </>
  )
}

const mapStateToProps = state => ({
  accountUnits: state.accounts.account.store_details.formatsAndUnits,
  receivingOrders: state.receivingOrders,
});

const mapDispatchToProps = (dispatch) => ({
  loadWarehouseReceivingOrders: (payload, purchaseOrderId) => dispatch(warehouseReceivingOrdersIndex(payload, purchaseOrderId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseReceivingOrders);
